import axios from "axios";

import { apiUrl, getAccessToken } from "./apis";

const fetchStatusRow = async () => {
  const token = getAccessToken();
  if (!token) return null;
  const response = await axios.get(
    `${apiUrl}delivery/dbdetails/?status_serializer=true`,
    { headers: { Authorization: token } }
  );
  return Array.isArray(response.data) ? response.data[0] || null : null;
};

export const fetchDutyStatus = async () => {
  const row = await fetchStatusRow();
  return row ? Boolean(row.status) : null;
};

export const fetchRiderState = async () => {
  const row = await fetchStatusRow();
  if (!row) return null;
  return {
    onDuty: Boolean(row.status),
    codLimit: row.cod_limit ?? null,
    cashInHand: Number(row.cash_in_hand ?? 0),
    codLimitReached: Boolean(row.cod_limit_reached),
  };
};

export const setDutyStatus = async (isOnDuty) => {
  const token = getAccessToken();
  if (!token) throw new Error("Not signed in");

  const data = new FormData();
  data.append("keyword", "status");
  data.append("status", isOnDuty ? "true" : "false");

  const response = await axios.patch(`${apiUrl}delivery/dbdetails/`, data, {
    headers: { Authorization: token, "Content-Type": "multipart/form-data" },
  });

  // The endpoint answers 200 with an error envelope when it refuses, so a
  // successful HTTP status is not enough to trust the flag changed.
  const message = response.data && response.data.Message;
  if (!message || typeof message.current_status !== "boolean") {
    throw new Error(
      (response.data && response.data.Error) || "Could not change duty status"
    );
  }
  return message.current_status;
};
